/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IaaCProjectRoleDTO } from './IaaCProjectRoleDTO';
import {
    IaaCProjectRoleDTOFromJSON,
    IaaCProjectRoleDTOFromJSONTyped,
    IaaCProjectRoleDTOToJSON,
} from './IaaCProjectRoleDTO';

/**
 * 
 * @export
 * @interface IaaCProjectMemberDTO
 */
export interface IaaCProjectMemberDTO {
    /**
     * 
     * @type {string}
     * @memberof IaaCProjectMemberDTO
     */
    email: string;
    /**
     * 
     * @type {IaaCProjectRoleDTO}
     * @memberof IaaCProjectMemberDTO
     */
    role: IaaCProjectRoleDTO;
}



/**
 * Check if a given object implements the IaaCProjectMemberDTO interface.
 */
export function instanceOfIaaCProjectMemberDTO(value: object): value is IaaCProjectMemberDTO {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function IaaCProjectMemberDTOFromJSON(json: any): IaaCProjectMemberDTO {
    return IaaCProjectMemberDTOFromJSONTyped(json, false);
}

export function IaaCProjectMemberDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): IaaCProjectMemberDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'role': IaaCProjectRoleDTOFromJSON(json['role']),
    };
}

export function IaaCProjectMemberDTOToJSON(value?: IaaCProjectMemberDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'role': IaaCProjectRoleDTOToJSON(value['role']),
    };
}

